var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcctiveBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Active Box"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.60132,
    y: 1.5,
    width: 16,
    height: 16,
    fill: "#345C8B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.60132,
    y: 1.5,
    width: 16,
    height: 16,
    stroke: "#CCCFCF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M13.4902 4.5L9.60132 8.38889L5.71243 4.5L4.60132 5.61111L8.49021 9.5L4.60132 13.3889L5.71243 14.5L9.60132 10.6111L13.4902 14.5L14.6013 13.3889L10.7124 9.5L14.6013 5.61111L13.4902 4.5Z",
    fill: "#CCCFCF",
    stroke: "#CCCFCF",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcctiveBox);
export default __webpack_public_path__ + "static/media/acctive-box.f3598fb90a2f5b82f5387ef594324eb6.svg";
export { ForwardRef as ReactComponent };